import { render } from "./ArrowDynamic.vue?vue&type=template&id=72460224&scoped=true&ts=true"
import script from "./ArrowDynamic.vue?vue&type=script&lang=ts"
export * from "./ArrowDynamic.vue?vue&type=script&lang=ts"

import "./ArrowDynamic.vue?vue&type=style&index=0&id=72460224&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72460224"]])

export default __exports__